/* eslint camelcase: "off" */

/**
 * Types of possible Alerts
 * @enum {string}
 */
export enum AlertType {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
  Info = 'info',
  Light = 'light',
  Dark = 'dark'
}

export interface Message {
  msg: string,
  type: AlertType,
  autoHide: boolean,
}

export interface Filter {
  group: string,
  key: string,
  value: string,
  label?: string
}

export interface InstancesWithSearchAndFilterState<T> {
  searchTerm: string,
  filters: Array<Filter>,
  instances: Array<T>,
  urlPart: string
}

export interface FilterGroupData {
  group: string,
  verbose: string,
  verboseNotActive: string
  filters: Array<Filter>,
  activeFilter: Filter | null
}

export const MAX_NUMBER_OF_DAYS = 150
